var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.106 14.9625C3.298 12.7985 0 10.2575 0 5.8525C0 0.989498 5.5 -2.4595 10 2.2165L12 4.2145C12.1422 4.34698 12.3302 4.4191 12.5245 4.41567C12.7188 4.41224 12.9042 4.33353 13.0416 4.19612C13.179 4.05871 13.2577 3.87332 13.2612 3.67902C13.2646 3.48472 13.1925 3.29667 13.06 3.1545L11.13 1.2215C15.369 -1.8815 20 1.3905 20 5.8525C20 10.2575 16.702 12.7985 13.894 14.9625C13.6007 15.1872 13.3153 15.4085 13.038 15.6265C12 16.4445 11 17.2155 10 17.2155C9 17.2155 8 16.4455 6.962 15.6255C6.684 15.4082 6.39867 15.1872 6.106 14.9625Z",
    fill: "url(#paint0_linear_552_61)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_552_61",
    x1: 20.6888,
    y1: 1.24181,
    x2: 3.16083,
    y2: 19.0887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E213A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF0527"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4591de3cdccefc9b47c7c3349564f6cc.svg";
export { ForwardRef as ReactComponent };